// @ts-nocheck
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { Card, TableRow,
  TableBody,
  TableCell,
  Table,
  Switch, 
  TableContainer, TablePagination,
  Grid, Button, Container, Stack, Typography, Pagination, Box } from '@mui/material';
// components
import AllParkingsListHead from '../sections/@dashboard/bookings/AllParkingsListHead';
import Scrollbar from '../components/Scrollbar';
import { BookingListToolbar } from '../sections/@dashboard/bookings';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import { SpacePostCard } from '../sections/@dashboard/parkings';
// mock
import { useEffect, useState } from 'react';
import { getActiveParkingSpaces, setParkings, getParkingTotalPages, getParkingTotalRecords } from '../store/state/parkingSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useGetAllParkingSpaceLocationMutation } from '../store/api/parkingsApi';
import Loading from '../components/Loading';
import SearchNotFound from '../components/SearchNotFound';
import { styled } from '@mui/material/styles';
import SpacePostSearchByName from '../sections/@dashboard/parkings/SpacePostSearchByName';
import toast from 'react-hot-toast';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'name', label: 'Model Name', alignRight: false },
  { id: 'regi. no', label: 'Reg. No', alignRight: false },
  { id: 'slots', label: 'Seating Capacity', alignRight: false },
  { id: 'address', label: 'Address', alignRight: false },
];
const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

const MarginBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '10px',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {},
}));

function capitalizeFirstLetter(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function VehicleOverview() {
  const navigate = useNavigate();
  const parkingSpacesData = useAppSelector(getActiveParkingSpaces);
  const totalPages = useAppSelector(getParkingTotalPages);
  const parkingTotalRecords = useAppSelector(getParkingTotalRecords);
  const [parkingSpaces, setParkingSpaces] = useState<any>([]);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [getAllParkingSpaceLocation, response] = useGetAllParkingSpaceLocationMutation();
  const [getAllPendingParkingSpaceCount, pendingResponse] = useGetAllParkingSpaceLocationMutation();
  const [pendingCount, setPendingCount] = useState(0);
  const dispatch = useAppDispatch();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const parkingsPerPage = 5;
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);


  const getAllParkingSpaceLocationAsync = async (pageNumber, parkingsPerPage, columnName, orderBy, searchTerm = '') => {
    await getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        page: pageNumber,
        offset: parkingsPerPage,
        columnName: columnName,
        orderBy: orderBy,
        name: searchTerm,
        serviceProviderId: token.serviceProviderId,
        currentStage: 'active',
      },
    });
  };

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  // Fetch parkings.
  useEffect(() => {
    if (token) {
      getAllPendingParkingSpaceCount({
        token: token.token,
        payload: {
          page: pageNumber,
          offset: parkingsPerPage,
          columnName: 'id',
          orderBy: 'desc',
          serviceProviderId: token.serviceProviderId,
          currentStage: 'pending',
        },
      });
    }
    setFilterName('');
  }, []);

  useEffect(() => {
    if (token) {
      getAllParkingSpaceLocationAsync(pageNumber, parkingsPerPage, 'id', 'desc');
    }
  }, []);

  // set data to store
  useEffect(() => {
    if (response.isSuccess) {
      dispatch(setParkings(response.data));
    }
    if (response.isError) {
      let errorData: any = response.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [response.isSuccess, response.isError]);

  useEffect(() => {
    if (pendingResponse.isSuccess) {
      setPendingCount(pendingResponse.data?.totalRecords);
    }
    if (pendingResponse.isError) {
      let errorData: any = pendingResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [pendingResponse.isSuccess, pendingResponse.isError]);

  const isUserNotFound = parkingSpaces?.length === 0;

  const displayParkings = parkingSpaces?.map((parkingSpace, index) => (
    <SpacePostCard key={index} navigate={navigate} parkingSpace={parkingSpace} index={index} />
  ));


  const handlePagination = (event: React.ChangeEvent<unknown>, page: number) => {
    setPageNumber(page - 1);
    getAllParkingSpaceLocationAsync(page - 1, parkingsPerPage, 'id', 'desc');
  };

  const handleSearchTerm = (event) => {
    setPageNumber(0);
    setSearchTerm(event.target.value);
    getAllParkingSpaceLocationAsync(pageNumber, parkingsPerPage, 'id', 'desc', event.target.value);
  };
  const filteredUsers = parkingSpaces;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
 
      dispatch(
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          name: event.target.value,
          serviceProviderId: token.serviceProviderId,
          currentStage: 'active',
        },
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        serviceProviderId: token.serviceProviderId,
        currentStage: 'active',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: 0,
        currentStage: 'active',
        serviceProviderId: token.serviceProviderId,
      },
    });
  };
  return (
    <Page title="Vehicle Overview">
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Vehicle Overview
          </Typography>
          <ResponsiveBox>
            <Box>
              <Button
                style={{
                  marginRight: '10px',
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                variant="contained"
                onClick={() => {
                  navigate('/dashboard/myparkingstatus');
                }}
              >
                Vehicle Status({pendingCount})
              </Button>
            </Box>
            <MarginBox>
              <Button
                style={{
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                variant="contained"
                onClick={() => {
                  navigate('/dashboard/addparking', { state: { isAdmin: false, editMode: false } });
                }}
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                Add
              </Button>
            </MarginBox>
          </ResponsiveBox>
        </Stack>

        <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between">
          <SpacePostSearchByName
            value={searchTerm}
            handleSearchTerm={handleSearchTerm}
            posts={parkingSpaces}
            placeholder={'Search'}
          />
        </Stack> */}

        {/* <Grid container spacing={3} marginBottom="20px"> 
          {displayParkings}
           {isUserNotFound && (
            <Box display="contents" justifyContent="center" height="10px" alignItems="center">
              <SearchNotFound searchQuery={parkingSpaces} />
            </Box>
          )}
        </Grid>
        {!isUserNotFound && (
          <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Pagination
              count={totalPages !== null ? totalPages : 1}
              siblingCount={0}
              color={'primary'}
              size={'large'}
              onChange={handlePagination}
            />
          </Box>
        )} */}

        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" marginBottom={0} gutterBottom>
              Vehicle Overview
            </Typography>
            <ResponsiveBox>
              <Box>
                <Button
                  style={{
                    marginRight: '10px',
                    color: 'white',
                    backgroundColor: '#E23744',
                  }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/myvehiclestatus');
                  }}
                >
                 Vehicle Status({pendingCount})
                </Button>
              </Box>
              <MarginBox>
                <Button
                  variant="contained"
                  style={{
                    color: 'white',
                    backgroundColor: '#E23744',
                  }}
                  onClick={() => {
                    navigate('/dashboard/addvehicle', { state: { isAdmin: false, editMode: false } });
                  }}
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  size="large"
                >
                  Add
                </Button>
              </MarginBox>
            </ResponsiveBox>
          </Stack>
          <Card sx={{ marginTop: '20px' }}>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Name'}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={parkingSpaces.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const { id, name, serviceProviderDetailResponseDTO, address, capacity, status, vehicleDetailObj } = row;
                        const isItemSelected = selected.indexOf(name) !== -1;
                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Typography
                                fontWeight="bold"
                                variant="subtitle2"
                                whiteSpace={'nowrap'}
                                onClick={() => {
                                  navigate('/dashboard/addvehicle', {
                                    state: { id: id, editMode: true, isAdmin: false, parkingSpace: row },
                                  });
                                }}
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                }}
                              >
                                {vehicleDetailObj?.model === null ? 'No Name Available' : vehicleDetailObj?.model}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{vehicleDetailObj?.registrationNumber}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography
                                variant="body2"
                              >
                                {vehicleDetailObj?.seatingCapacity}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{address}</Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={parkingTotalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
          </Container>
      {response.isLoading && <Loading />}
    </Page>
  );
}
